// client/src/pages/Profile.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import request from '../utils/request';
import { getCityName } from '../utils/region';
import { useWxShare } from '../hooks/useWxShare';

function Profile() {
  const [user, setUser] = useState(null);
  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // 获取用户资料
      const userRes = await request({ url: '/api/user/me', method: 'GET' });
      setUser(userRes.data);

      // 获取名额信息
      const quotaRes = await request({ url: '/api/quota', method: 'GET' });
      setQuota(quotaRes.data);
    } catch (err) {
      console.error('获取数据失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const genderText = user?.gender === 'male' ? '男' : (user?.gender === 'female' ? '女' : null);
  const cityName = getCityName(user?.city) || user?.city;
  const basicInfo = [genderText, user?.age ? `${user.age}岁` : null, cityName].filter(Boolean).join(' · ');
  const needComplete = !user?.nickname || !user?.city || !user?.job || user?.gender === 'unknown';

  useWxShare({
    title: user ? `${user.nickname} - AI相亲助手` : 'AI相亲助手',
    desc: basicInfo ? `${basicInfo} · 来认识我吧` : '智能匹配，轻松脱单',
    imgUrl: user?.avatar
  });

  if (loading) {
    return (
      <Layout>
        <div className="loading">加载中...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <h2 style={{ marginBottom: 20 }}>👤 我的主页</h2>

      {/* 用户信息卡片 - 头像和昵称一排 */}
      <div className="card" style={{ overflow: 'hidden' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          padding: '4px 0'
        }}>
          <img
            src={user?.avatar || 'https://via.placeholder.com/80'}
            alt="avatar"
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              objectFit: 'cover',
              flexShrink: 0,
              border: '3px solid #ffe8e8'
            }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <h2 style={{ fontSize: 22, margin: 0, fontWeight: 600, color: '#333' }}>
              {user?.nickname || '未设置'}
            </h2>
            {basicInfo && (
              <p style={{ color: '#888', fontSize: 14, marginTop: 6, marginBottom: 0 }}>{basicInfo}</p>
            )}
            {user?.job && (
              <p style={{ color: '#666', fontSize: 14, marginTop: basicInfo ? 4 : 6 }}>{user.job}</p>
            )}
            <p style={{ color: '#bbb', fontSize: 12, marginTop: 6 }}>ID: {user?.id}</p>
          </div>
        </div>

        {needComplete && (
          <div style={{
            marginTop: 16,
            paddingTop: 16,
            borderTop: '1px solid #f0f0f0'
          }}>
            <p style={{ color: '#999', fontSize: 14, marginBottom: 12 }}>资料未完善，完善后才能更好匹配</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/profile/edit')}
            >
              去完善资料
            </button>
          </div>
        )}
      </div>

      {/* 会员信息 */}
      <div className="card">
        <h3 style={{ marginBottom: 12 }}>💰 会员信息</h3>
        {quota ? (
          <>
            <p>剩余名额：{quota.remaining}/{quota.total}</p>
            <p style={{ color: '#666', fontSize: 14, marginTop: 8 }}>
              有效期至：{new Date(quota.expires_at).toLocaleDateString()}
            </p>
          </>
        ) : (
          <>
            <p style={{ color: '#999' }}>暂无会员</p>
            <button 
              className="btn btn-primary" 
              style={{ marginTop: 12 }}
              onClick={() => navigate('/membership')}
            >
              立即开通
            </button>
          </>
        )}
      </div>

      {/* 功能菜单 */}
      <div className="card">
        <div 
          style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 0',
            borderBottom: '1px solid #eee',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/profile/edit')}
        >
          <span>📝 编辑资料</span>
          <span style={{ color: '#999' }}>→</span>
        </div>
        <div 
          style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 0',
            borderBottom: '1px solid #eee',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/match-history')}
        >
          <span>📋 牵线记录</span>
          <span style={{ color: '#999' }}>→</span>
        </div>
        <div 
          style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 0',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/settings')}
        >
          <span>⚙️ 设置</span>
          <span style={{ color: '#999' }}>→</span>
        </div>
      </div>
    </Layout>
  );
}

export default Profile;
